const DEFAULT_SAMPLE_SIZE = 40;
const DEFAULT_ALPHA_THRESHOLD = 10;

export const getImageAverageLuminance = (src: string, sampleSize = DEFAULT_SAMPLE_SIZE): Promise<number | null> => {
  if (!src || typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const size = Math.max(1, sampleSize);
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) {
        resolve(null);
        return;
      }

      ctx.drawImage(img, 0, 0, size, size);

      let data: Uint8ClampedArray;
      try {
        data = ctx.getImageData(0, 0, size, size).data;
      } catch (err) {
        resolve(null);
        return;
      }

      let total = 0;
      let count = 0;
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha < DEFAULT_ALPHA_THRESHOLD) continue;
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
        total += luminance;
        count += 1;
      }

      resolve(count ? total / count : null);
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
};

export const isLightImage = async (src: string, threshold = 0.82): Promise<boolean | null> => {
  const luminance = await getImageAverageLuminance(src);
  if (luminance === null) return null;
  return luminance >= threshold;
};
